<template>
  <div>
    <div v-if="period.isOngoing()">
      <p class="text-muted">{{ $t('global.summary') }}</p>
      <long-term-period-summary :period="period" />
      <long-term-period-insight :company="company" :period="period" />

      <Divider />
    </div>
    <long-term-period-settings :period="period" :company="company" />
    <div v-if="period.getPromisedTotal().asWh() > 0">
      <Divider />

      <long-term-period-gap-fills
        :company="company"
        :period="period"
        @fetch-required="$emit('fetch-required')"
      />

      <Divider />

      <long-term-period-explainer :period="period" />

      <long-term-period-progress-chart
        style="height: 100px; width: 95%"
        :period="period"
        class="mt-4"
      />
    </div>
  </div>
</template>
<script lang="ts">
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';
import Company from '@/domain/model/business/Company';
import LongTermPeriodExplainer from '@/presentation/components/long-term-period/LongTermPeriodExplainer.vue';
import LongTermPeriodSettings from '@/presentation/components/long-term-period/LongTermPeriodSettings.vue';
import LongTermPeriodSummary from '@/presentation/components/long-term-period/LongTermPeriodSummary.vue';
import LongTermPeriodProgressChart from '@/presentation/components/long-term-period/LongTermPeriodProgressChart.vue';
import LongTermPeriodGapFills from '@/presentation/components/long-term-period/LongTermPeriodGapFills.vue';
import LongTermPeriodInsight from '@/presentation/components/long-term-period/LongTermPeriodInsight.vue';

export default {
  name: 'LongTermPeriod',
  components: {
    LongTermPeriodExplainer,
    LongTermPeriodGapFills,
    LongTermPeriodInsight,
    LongTermPeriodSettings,
    LongTermPeriodSummary,
    LongTermPeriodProgressChart,
  },
  emits: ['fetch-required'],
  props: {
    company: { type: Company },
    period: { type: YieldPromiseStatus },
  },
};
</script>
